var map = {
	"./WP_000205.jpg": 195270,
	"./WP_000216.jpg": 177718,
	"./WP_000255.jpg": 466469,
	"./WP_000272.jpg": 129652,
	"./WP_000313.jpg": 777750,
	"./WP_000385.jpg": 894691
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 700286;